import { Workspace } from '../../clients/aasServerClient.generated';
import {
    ActionTypeNames,
    AssignApplicationsWorkspaceAction,
    AssignGroupsWorkspacesAction,
    ClearSingleWorkspaceAction,
    CopySingleWorkspaceAction,
    CreateSingleWorkspaceAction,
    FetchAllWorkspacesAction,
    FetchSingleWorkspaceAction,
    FetchTableWorkspacesAction,
    FetchTableWorkspacesNFAction,
    NewSingleWorkspaceAction,
    SavedSingleWorkspaceAction,
    SaveSingleWorkspaceAction,
    StoreAllWorkspacesAction,
    StoreSingleWorkspaceAction,
    StoreTableWorkspacesAction,
    WorkspacesAction,
} from './actions';

export function fetchTableWorkspaces(): FetchTableWorkspacesAction {
    return {
        type: ActionTypeNames.FetchTableWorkspaces
    };
}

export function fetchTableWorkspacesNF(): FetchTableWorkspacesNFAction {
    return {
        type: ActionTypeNames.FetchTableWorkspacesNF
    };
}

export function fetchAllWorkspaces(): FetchAllWorkspacesAction {
    return {
        type: ActionTypeNames.FetchAllWorkspaces
    };
}

export function fetchSingleWorkspace(id: string): FetchSingleWorkspaceAction {
    return {
        id,
        type: ActionTypeNames.FetchSingleWorkspace
    };
}
export function newSingleWorkspace(): NewSingleWorkspaceAction {
    return {
        type: ActionTypeNames.NewSingleWorkspace
    };
}

export function copySingleWorkspace(id: string): CopySingleWorkspaceAction {
    return {
        id,
        type: ActionTypeNames.CopySingleWorkspace
    };
}

export function storeSingleWorkspace(workspace: Partial<Workspace>): StoreSingleWorkspaceAction {
    return {
        type: ActionTypeNames.StoreSingleWorkspace,
        workspace,
    };
}

export function saveSingleWorkspace(
    workspace: Partial<Workspace>,
    parentId?: string,
    groups?: Array<{ id: string, value: boolean }>
): SaveSingleWorkspaceAction {
    return {
        groups,
        parentId,
        type: ActionTypeNames.SaveSingleWorkspace,
        workspace,
    };
}

export function createSingleWorkspace(
    workspace: Partial<Workspace>,
    parentId?: string,
    groups?: Array<{ id: string, value: boolean }>
): CreateSingleWorkspaceAction {
    return {
        groups,
        parentId,
        type: ActionTypeNames.CreateSingleWorkspace,
        workspace,
    };
}

export function clearSingleWorkspace(): ClearSingleWorkspaceAction {
    return {
        type: ActionTypeNames.ClearSingleWorkspace,
    };
}

export function savedSingleWorkspace(): SavedSingleWorkspaceAction {
    return {
        type: ActionTypeNames.SavedSingleWorkspace,
    };
}

function workspacesActionCreator<T extends ActionTypeNames>(type: T) {
    return (ids: string[]): WorkspacesAction<T> => {
        return {
            type,
            workspaceIds: ids,
        };
    };
}

export function storeTableWorkspaces(workspaces: Workspace[]): StoreTableWorkspacesAction {
    return {
        type: ActionTypeNames.StoreTableWorkspaces,
        workspaces,
    };
}

export function storeAllWorkspaces(workspaces: Workspace[]): StoreAllWorkspacesAction {
    return {
        type: ActionTypeNames.StoreAllWorkspaces,
        workspaces,
    };
}

export const deleteWorkspaces = workspacesActionCreator(ActionTypeNames.DeleteWorkspaces);

export function assignGroupsWorkspaces(
    workspaceIds: string[],
    groupIds: string[],
): AssignGroupsWorkspacesAction {
    return {
        groupIds,
        type: ActionTypeNames.AssignGroupsWorkspaces,
        workspaceIds,
    };
}

export function assignApplicationsWorkspace(
    applicationIds: string[],
    workspaceId: string,
): AssignApplicationsWorkspaceAction {
    return {
        applicationIds,
        type: ActionTypeNames.AssignApplicationsWorkspace,
        workspaceId,
    };
}

/* export function deleteWorkspace(name: string): DeleteWorkspaceAction {
    return {
        type: ActionTypeNames.DeleteWorkspace,
        name
    };
}

export function addWorkspace(Workspace: Workspace): AddWorkspaceAction {
    return {
        type: ActionTypeNames.AddWorkspace,
        Workspace
    };
}
 */
